const WIDTH_MAP = {
  '3xl': 'max-w-3xl',
  '5xl': 'max-w-5xl',
  '6xl': 'max-w-6xl',
  '7xl': 'max-w-7xl',
};

const PADDING_MAP = {
  sm: 'marketing-section--sm',
  md: 'marketing-section--md',
  lg: 'marketing-section--lg',
  none: 'marketing-section--none',
};

export default function MarketingSection({
  children,
  maxWidth = '5xl',
  padding = 'lg',
  className = '',
}) {
  const containerClass = WIDTH_MAP[maxWidth] || WIDTH_MAP['5xl'];
  const paddingClass = PADDING_MAP[padding] || PADDING_MAP.lg;

  return (
    <section className={`marketing-section ${paddingClass} ${className}`.trim()}>
      <div className={`${containerClass} mx-auto px-8 lg:px-12`}>
        {children}
      </div>
    </section>
  );
}
